export default __webpack_public_path__ + "static/media/cabello-mujer-negro.2480082f.png";